import React from 'react';
import { CheckIcon } from 'lucide-react';
const benefits = ['Más energía desde la primera semana', 'Menos hinchazón y vientre más plano', 'Pérdida de peso progresiva y sostenible', 'Mejor relación con la comida (sin culpa)', 'Piel más luminosa y menos retención de líquidos', 'Mejor descanso y menos ansiedad', 'Claridad mental y mejor humor', 'Un método que podés mantener de por vida'];
export function BenefitsSection() {
  return <section className="py-12 bg-sage-light/30" data-id="element-21">
      <div className="container mx-auto px-4 max-w-4xl fade-in-section" data-id="element-22">
        <div className="text-center mb-8" data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark mb-4" data-id="element-24">
            Esto es lo que vas a experimentar
          </h2>
          <p className="text-lg text-text-medium" data-id="element-25">
            Cuando tu metabolismo funciona a tu favor, todo cambia.
          </p>
        </div>

        <div className="bg-white rounded-3xl p-6 md:p-8 shadow-card border border-sage-light" data-id="element-26">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-27">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start" data-id="element-28">
                <div className="flex-shrink-0 mt-1 bg-sage/20 p-1 rounded-full mr-4" data-id="element-29">
                  <CheckIcon className="text-sage font-bold" size={20} data-id="element-30" />
                </div>
                <span className="text-lg text-text-dark font-medium" data-id="element-31">
                  {benefit}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}